import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { loadMembershipData } from "../store/features/memberhsip/membershipActions";
import { loadOrganizationData } from "../store/features/organization/organizationActions";
import { loadAdvisorData } from "../store/features/user/userActions";

/**
 * Carga lo que la sesión necesita en la store: el asesor, luego su organización y, si la
 * organización tiene el módulo de inquilinos, su membresía. Cada pieza se pide una vez, cuando ya
 * está la anterior.
 *
 * Lo monta cada layout de las páginas con sesión (el `Header` del tablero y `FullScreenLayout`):
 * sin él, `userData` nunca llega y las guardas que lo esperan (`ContractPermissionGuard`) dejan la
 * página en blanco al entrar directo o recargar.
 */
export function useSessionData(): void {
  const dispatch = useDispatch<any>();
  const { userToken } = useSelector((state: any) => state.entities.auth);
  const { userData } = useSelector((state: any) => state.entities.user);
  const { membershipData } = useSelector(
    (state: any) => state.entities.membership,
  );
  const { organizationData } = useSelector(
    (state: any) => state.entities.organization,
  );

  useEffect(() => {
    if (userToken) {
      if (!userData) {
        dispatch(loadAdvisorData(userToken));
      }
    }

    if (userData && userData.organization_id) {
      if (!organizationData) {
        dispatch(loadOrganizationData(userData.organization_id));
      }
    }

    if (organizationData && organizationData.modules.includes("tenant")) {
      if (!membershipData) {
        dispatch(loadMembershipData(organizationData.membership_id));
      }
    }
  }, [userToken, userData, membershipData, organizationData]);
}
